import Model from './Model'
import ResourceVideoAttachment from './ResourceVideoAttachment'

export default class ResourceVideo extends Model {
  resource() {
    return 'videos'
  }

  attachments() {
    return this.hasMany(ResourceVideoAttachment)
  }
}
